/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Noprevious1Inputs */

const id_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada build terverifikasi sebelumnya`)
};

const ms_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada binaan disahkan sebelumnya`)
};

const da_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intet tidligere bekræftet build`)
};

const de_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein vorheriger verifizierter Build`)
};

const en_us2_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No previous verified build`)
};

const es_es2_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay una compilación anterior verificada`)
};

const es_mx2_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay una compilación anterior verificada`)
};

const fil_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang naunang na-verify na build`)
};

const fr_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun build vérifié précédent`)
};

const it_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna build verificata precedente`)
};

const hu_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs korábbi ellenőrzött build`)
};

const nl_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen eerdere geverifieerde build`)
};

const no_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tidligere bekreftet build`)
};

const pl_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak wcześniejszego zweryfikowanego buildu`)
};

const pt_br2_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum build verificado anterior`)
};

const pt_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma compilação anterior verificada`)
};

const ro_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu există un build verificat anterior`)
};

const fi_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aiemmin vahvistettua buildia ei ole`)
};

const sv_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tidigare verifierad build`)
};

const vi_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có build đã xác minh trước đó`)
};

const tr_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önceki doğrulanmış derleme yok`)
};

const cs_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný předchozí ověřený build`)
};

const bg_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма предишна проверена компилация`)
};

const ru_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет предыдущей проверенной сборки`)
};

const uk_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Немає попереднього перевіреного білду`)
};

const ar_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا يوجد بناء سابق تم التحقق منه`)
};

const hi_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पिछला सत्यापित बिल्ड नहीं`)
};

const th_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีบิลด์ที่ยืนยันก่อนหน้านี้`)
};

const ja_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以前に検証されたビルドはありません`)
};

const zh_cn2_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有之前已验证的构建`)
};

const zh_hant1_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有先前已驗證的組建`)
};

const ko_builds_comparison_noprevious1 = /** @type {(inputs: Builds_Comparison_Noprevious1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이전에 검증된 빌드가 없음`)
};

/**
* | output |
* | --- |
* | "No previous verified build" |
*
* @param {Builds_Comparison_Noprevious1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_noprevious1 = /** @type {((inputs?: Builds_Comparison_Noprevious1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Noprevious1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_noprevious1(inputs)
	if (locale === "ms") return ms_builds_comparison_noprevious1(inputs)
	if (locale === "da") return da_builds_comparison_noprevious1(inputs)
	if (locale === "de") return de_builds_comparison_noprevious1(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_noprevious1(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_noprevious1(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_noprevious1(inputs)
	if (locale === "fil") return fil_builds_comparison_noprevious1(inputs)
	if (locale === "fr") return fr_builds_comparison_noprevious1(inputs)
	if (locale === "it") return it_builds_comparison_noprevious1(inputs)
	if (locale === "hu") return hu_builds_comparison_noprevious1(inputs)
	if (locale === "nl") return nl_builds_comparison_noprevious1(inputs)
	if (locale === "no") return no_builds_comparison_noprevious1(inputs)
	if (locale === "pl") return pl_builds_comparison_noprevious1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_noprevious1(inputs)
	if (locale === "pt") return pt_builds_comparison_noprevious1(inputs)
	if (locale === "ro") return ro_builds_comparison_noprevious1(inputs)
	if (locale === "fi") return fi_builds_comparison_noprevious1(inputs)
	if (locale === "sv") return sv_builds_comparison_noprevious1(inputs)
	if (locale === "vi") return vi_builds_comparison_noprevious1(inputs)
	if (locale === "tr") return tr_builds_comparison_noprevious1(inputs)
	if (locale === "cs") return cs_builds_comparison_noprevious1(inputs)
	if (locale === "bg") return bg_builds_comparison_noprevious1(inputs)
	if (locale === "ru") return ru_builds_comparison_noprevious1(inputs)
	if (locale === "uk") return uk_builds_comparison_noprevious1(inputs)
	if (locale === "ar") return ar_builds_comparison_noprevious1(inputs)
	if (locale === "hi") return hi_builds_comparison_noprevious1(inputs)
	if (locale === "th") return th_builds_comparison_noprevious1(inputs)
	if (locale === "ja") return ja_builds_comparison_noprevious1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_noprevious1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_noprevious1(inputs)
	return ko_builds_comparison_noprevious1(inputs)
});
export { builds_comparison_noprevious1 as "builds.comparison.noPrevious" }